import React from 'react';
import { FaGithub, FaLinkedin } from 'react-icons/fa6';
import './PresentacionStyle.css';

function Presentacion() {
    return (
        <div className='presentacion-contenedor'>
            <div className='presentacion-introduccion'>
                <div>
                    <p>Mi carrera como desarrolladora web comenzó en 2007 en el departamento digital de una agencia de comunicación de ámbito nacional.</p>
                    <p>Desde entonces, he colaborado con diversas agencias de marketing y diseño web, participando en una amplia variedad de proyectos digitales.</p>
                    <p>Mi trayectoria me ha brindado una visión integral del desarrollo web, abarcando todas las etapas del proceso: desde la concepción inicial hasta el mantenimiento y la mejora continua.</p>
                    <p>Mi especialidad es el desarrollo en WordPress y WooCommerce, donde combino una sólida base en tecnologías front-end con una visión global de la gestión de proyectos web.</p>
                    <p>En un sector tan cambiante, apuesto por la formación continua como herramienta clave para seguir creciendo y perfeccionar cada día mi manera de trabajar.</p>
                    <p className='parrafo-destacado'>Te invito a echar un vistazo a mi portfolio, donde encontrarás una selección de proyectos en los he trabajado recientemente.</p>
                </div>
            </div>
        </div>
    )
}

export default Presentacion;